import React from 'react';

const Contact = () => {
  const contactMethods = [
    {
      icon: 'email',
      title: 'Email',
      value: 'nguyencongphongvu@outlook.com',
      action: () => window.open('mailto:nguyencongphongvu@outlook.com')
    },
    {
      icon: 'code',
      title: 'GitHub',
      value: 'github.com/uproject-mine',
      action: () => window.open('https://github.com/uproject-mine/', '_blank')
    },
    {
      icon: 'music_note',
      title: 'TikTok',
      value: '@u_project_',
      action: () => window.open('https://tiktok.com/@u_project_', '_blank')
    },
    {
      icon: 'web',
      title: 'Website',
      value: 'uproject.io.vn',
      action: () => window.open('https://uproject.io.vn', '_blank')
    }
  ];

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="section-title">Liên hệ</h2>
            <p className="section-description">
              Quan tâm đến các dự án HUD DIY hoặc có ý tưởng build tùy chỉnh? 
              Liên hệ với chúng tôi qua các kênh bên dưới.
            </p>
            <div className="contact-methods">
              {contactMethods.map((method, index) => (
                <div key={index} className="contact-method" onClick={method.action}>
                  <span className="material-icons">{method.icon}</span>
                  <div>
                    <h4>{method.title}</h4>
                    <p>{method.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
